import { useTranslation } from 'react-i18next'
import { Card, CardBody } from '../components/ui/Card'
import { PageScrollArea, PageView } from '../components/ui/PageScrollArea'
import { PageHeader } from '../components/ui/PageHeader'
import { ComingSoonPreview } from '../components/ComingSoonPreview'
import { COMING_SOON_VOTE_FEATURE } from '../lib/previewVoteFeature'

// Matches the prototype's `section-tlimits` — a Preview-only page, no real
// backend behind it (see ARCHITECTURE_DECISIONS.md).
export function TenantLimits() {
  const { t } = useTranslation()
  return (
    <PageView>
      <PageHeader title={t('tenantLimits.title')} subtitle={t('tenantLimits.subtitle')} />
      <PageScrollArea>
        <Card>
          <CardBody>
            <ComingSoonPreview
              title={t('tenantLimits.title')}
              description={t('tenantLimits.description')}
              feature={COMING_SOON_VOTE_FEATURE.tenantLimits}
            />
          </CardBody>
        </Card>
      </PageScrollArea>
    </PageView>
  )
}
